const NOW = new Date("2026-04-01T12:00:00Z").getTime();
const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;

export interface ResourceFieldValue {
  label: string;
  value: string;
  /** Optional confidence score 0..1 used to render an indicator. */
  confidence?: number;
}

export interface ResourceLinkedItem {
  id: string;
  type: string;
  label: string;
  href?: string;
}

export interface ResourceActivityEntry {
  id: string;
  actor: string;
  action: string;
  timestamp: number;
}

export interface ResourcePageFixture {
  id: string;
  title: string;
  eyebrow: string;
  status: { label: string; tone: "draft" | "processing" | "review" | "complete" };
  meta: string;
  owner: string;
  createdAt: number;
  updatedAt: number;
  fields: ResourceFieldValue[];
  linked: ResourceLinkedItem[];
  activity: ResourceActivityEntry[];
}

export const resourcePageFixture: ResourcePageFixture = {
  id: "rec_2891",
  title: "Claim #C-2891 \u2014 water damage on 1428 Maple Ave",
  eyebrow: "Records / Claims",
  status: { label: "review", tone: "review" },
  meta: "12 fields \u00b7 3 citations \u00b7 2 active runs",
  owner: "Maya Chen",
  createdAt: NOW - 6 * DAY,
  updatedAt: NOW - 2 * HOUR,
  fields: [
    { label: "Insured", value: "Robert Hartley", confidence: 0.98 },
    { label: "Policy number", value: "HO-44-2218-A", confidence: 0.99 },
    { label: "Loss date", value: "2026-03-26", confidence: 0.94 },
    { label: "Loss type", value: "Sudden water discharge \u2014 supply line", confidence: 0.91 },
    { label: "Reported by", value: "Insured (phone)", confidence: 1 },
    { label: "Adjuster", value: "Maya Chen", confidence: 1 },
    { label: "Estimated reserve", value: "$28,400", confidence: 0.72 },
    { label: "Coverage A", value: "$320,000" },
    { label: "Coverage B", value: "$32,000" },
    { label: "Deductible", value: "$1,500" },
    { label: "Inspection date", value: "2026-03-29", confidence: 0.88 },
    { label: "Mitigation vendor", value: "Allstar Restoration", confidence: 0.81 },
  ],
  linked: [
    { id: "pol_1142", type: "Policy", label: "HO-44-2218-A", href: "#policy" },
    { id: "acc_988", type: "Account", label: "Hartley household", href: "#account" },
    { id: "doc_4421", type: "Document", label: "First notice of loss.pdf", href: "#doc-1" },
    { id: "doc_4422", type: "Document", label: "Plumber invoice.pdf", href: "#doc-2" },
    { id: "art_311", type: "Artifact", label: "Damage estimate v2.xlsx", href: "#artifact" },
  ],
  activity: [
    {
      id: "act_1",
      actor: "Maya Chen",
      action: "Updated estimated reserve to $28,400",
      timestamp: NOW - 2 * HOUR,
    },
    {
      id: "act_2",
      actor: "Evidence Verifier",
      action: "Linked plumber invoice to claim",
      timestamp: NOW - 5 * HOUR,
    },
    {
      id: "act_3",
      actor: "Triage Copilot",
      action: "Routed claim to property team",
      timestamp: NOW - 1 * DAY,
    },
    {
      id: "act_4",
      actor: "System",
      action: "Claim opened from FNOL intake",
      timestamp: NOW - 6 * DAY,
    },
  ],
};
